import { useLazyGetFileQuery } from '@saaga/shared/store/file-agents-endpoints.store'
import { logger } from '@saaga/shared/utils/logger.util'
import { useCallback } from 'react'
import { toast } from 'sonner'

export const useAttachmentDownload = () => {
  const [triggerGetFile] = useLazyGetFileQuery()

  const handleAttachmentDownload = useCallback(
    async (attachmentId: string) => {
      try {
        const result = await triggerGetFile(attachmentId)
        if (!result.data?.download_url) {
          toast.error('Failed to download file')
          return
        }
        window.open(result.data.download_url, '_blank')
      } catch (error) {
        logger.error('Failed to download attachment', error)
        toast.error('Failed to download file')
      }
    },
    [triggerGetFile]
  )

  return { handleAttachmentDownload }
}
